import {Injectable} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {GrannyFlatPickerComponent} from '../module/granny-flat-picker/granny-flat-picker.component';
import {GrannyFlatSelection} from '../models/request/prospect/granny-flat-link';
import {AddressRequest} from '../models/request/address/address-request';

@Injectable({providedIn: 'root'})
export class GrannyFlatPickerService {
  constructor(private dialogs: NbDialogService) {}
  choose(address: AddressRequest, officeId?: number, prospectId?: number): Observable<GrannyFlatSelection> {
    return this.dialogs.open(GrannyFlatPickerComponent, {
      context: {address: {...address}, officeId, prospectId}, closeOnBackdropClick: false,
    }).onClose.pipe(take(1));
  }
  addressKey(address: AddressRequest): string {
    return JSON.stringify([address?.streetId, String(address?.numberFrom || ''), address?.numberTo || '',
      address?.numberFromLetter || '', address?.numberToLetter || '', address?.additionalInfo || '', address?.unit || '']);
  }
}
